import { Block } from "./Block";
import { GameVars } from "../../GameVars";
import { BoardContainer } from "./BoardContainer";
import { BoardScene } from "./BoardScene";
import * as Templok from "@ravalmatic/templok-engine";
import { GameManager } from "../../GameManager";
import { GameOverLayer } from "./GameOverLayer";

export class BoardManager {

    public static currentInstance: BoardManager;

    private selectedBlockPosition: {c: number, r: number};
    
    constructor () {

        BoardManager.currentInstance = this;
        
        GameVars.gameOver = false;

        GameVars.numOfCellDestroyed = -1;
        GameVars.score = 0;
        GameVars.reRolling = false;
        GameVars.paused = true;

        if (GameVars.resumedGame) {
            this.startResumedGame();
        } else {
            this.startGame();
        }

        // TODO: remove this
        // GameVars.currentScene.time.delayedCall(1000, function(): void {
        //         BoardManager.currentInstance.onGameOver();
        //     }
        // );

        GameVars.rewardedAdAvailable = false;

        if (gdsdk !== "undefined" && gdsdk.preloadAd !== "undefined") {
            gdsdk
              .preloadAd("rewarded")
              .then(response => {
                    GameVars.rewardedAdAvailable = true;
              })
              .catch(error => {
                // Any Rewarded ad is not available to user.
              });
          }
    }

    public update(): void {

        if (GameVars.selectedBlock && GameVars.selectedBlock.dragging) {

            const p = GameVars.selectedBlock.getPositionOnBoard();
            const isHoverPositionValid = GameVars.templokEngine.checkDropPosition(p, GameVars.selectedBlock.blockData);

            BoardContainer.currentInstance.unMarkPossibleLinesAndColumns();

            if (isHoverPositionValid) {

                BoardContainer.currentInstance.markShadows(p, GameVars.selectedBlock.blockData);

                const linesAndColumnsData = GameVars.templokEngine.getHoverRowsAndColumns(p, GameVars.selectedBlock.blockData);

                const rows = linesAndColumnsData.rows;
                const columns = linesAndColumnsData.columns;
                const duplicatedCells = linesAndColumnsData.duplicatedCells;

                BoardContainer.currentInstance.markPossibleLinesAndColumns(rows, columns, duplicatedCells);
                    
            } else {

                BoardContainer.currentInstance.unMarkShadows(); 
            }
        }
    }

    public startResumedGame(): void {

        GameVars.paused = false;

        GameVars.templokEngine = new Templok.Engine();
        GameVars.templokEngine.init();
        GameVars.templokEngine.processActions(GameVars.gameData.logs);

        this.addEngineListeners();

        GameVars.score = GameVars.templokEngine.score;

        BoardScene.currentInstance.startGame();

        if (GameVars.templokEngine.blocksOnDispenser.length === 0) {
            GameVars.templokEngine.spawnBlocks();
        }

        const isGameOver = GameVars.templokEngine.checkGameOver();

        if (isGameOver) {
            this.onGameOver();
        }
    }

    public startGame(): void {

        GameVars.paused = false;

        GameVars.templokEngine = new Templok.Engine();
        GameVars.templokEngine.init();

        const seed = Math.floor(Math.random() * 1e5);
        GameVars.templokEngine.setSeed(seed);

        const action: Templok.Action = {type: Templok.ActionType.START_GAME, data: {seed: seed}};
        GameVars.gameData.logs.push(action);
        GameManager.writeGameData();

        this.addEngineListeners();

        BoardScene.currentInstance.startGame();

        GameVars.templokEngine.spawnBlocks();
    }

    public pauseGame(): void {

        GameVars.paused = true;

        BoardScene.currentInstance.pause();
    }

    public resumeGame(): void {

        GameVars.paused = false;

        BoardScene.currentInstance.resume();
    }

    public showRules(): void {

        BoardScene.currentInstance.showRules();
    }

    public removeRules(): void {

        BoardScene.currentInstance.removeRules();
    }

    public onBlockReleased(p: {c: number, r: number}): void {

        this.selectedBlockPosition = p;

        GameVars.templokEngine.onBlockReleased(p, GameVars.selectedBlock.blockData, GameVars.selectedBlock.isOnNiche);
    }

    public onBlockReleasedOnNiche(): void {

        GameVars.templokEngine.onBlockReleasedOnNiche(GameVars.selectedBlock.blockData);
    }

    public onBlockSelected(block: Block): void {

        GameVars.selectedBlock = block;

        GameVars.templokEngine.onBlockSelected(GameVars.selectedBlock.blockData);
    }

    public onPointerUp(): void {

        if (GameVars.selectedBlock) {
            
            GameVars.selectedBlock.onPointerUp();
            GameVars.selectedBlock = null;
        }
    }

    public onBlockNotFitting(droppedOutsideBoard?: boolean): void {
        
        BoardContainer.currentInstance.returnToOrigin(GameVars.selectedBlock, droppedOutsideBoard);

        BoardContainer.currentInstance.blocksDispenser.checkBlocks();

        BoardContainer.currentInstance.unMarkDropPosition();
        BoardContainer.currentInstance.unMarkShadows();
    }

    public reRoll(): void {

        GameVars.paused = true;

        const action: Templok.Action = {type: Templok.ActionType.RERROLL, data: null};
        GameVars.gameData.logs.push(action);
        GameManager.writeGameData();

        GameVars.templokEngine.reRoll();
    }

    public onBlockReRolled(): void {

        GameVars.reRolling = false;
        GameVars.paused = false;

        const blockOnNiche = BoardContainer.currentInstance.blocksDispenser.niche.block;

        if (!GameVars.templokEngine.doesBlockFitInBoard(blockOnNiche.blockData)) {
            
            blockOnNiche.disable();
        }

        if (GameVars.gameOver) {
            this.onGameOver();
        }
    }

    public rotate(): void {

        GameVars.paused = true;
        
        GameVars.templokEngine.rotate();

        const action = {type: Templok.ActionType.ROTATE, data:  null};
        GameVars.gameData.logs.push(action);
        GameManager.writeGameData();
    }

    public onRotationCompleted(): void {

        GameVars.paused = false;
    }
    public onGameOver(): void {

        GameVars.resumedGame = false;

        GameVars.gameOver = true;
        
        if (GameVars.reRolling) {
            return;
        }

        BoardScene.currentInstance.onGameOver();
    }

    public onRestart(): void {

        GameVars.gameOver = false;
        GameVars.resumedGame = false;

        GameVars.gameData.logs = [];
        GameManager.writeGameData();

        GameManager.enterBoardScene();
    }

    public onBoosterPurchased(): void {

        if (gdsdk !== "undefined" && gdsdk.showAd !== "undefined") {
            gdsdk.showAd("rewarded")
            .then(response => {
              // Ad process done. You can track "SDK_REWARDED_WATCH_COMPLETE" event if that event triggered, that means the user watched the advertisement completely, you can give reward there.
                GameVars.gameOver = false;
                GameVars.templokEngine.onBoosterPurchased();
                BoardScene.currentInstance.onBoosterPurchased();

                const action = {type: Templok.ActionType.PURCHASE_BOOSTER, data: null};
                GameVars.gameData.logs.push(action);
                GameManager.writeGameData();
            })
            .catch(error => {
              // An error catched. Please don"t give reward here.
              GameOverLayer.currentInstance.rewardedAddButtonContainer.visible = false;
            });
        } else {
            GameVars.gameOver = false;
            GameVars.templokEngine.onBoosterPurchased();
            BoardScene.currentInstance.onBoosterPurchased();

             const action = {type: Templok.ActionType.PURCHASE_BOOSTER, data: null};
            GameVars.gameData.logs.push(action);
            GameManager.writeGameData();
    }
    }

    public forceGameOver(): void {

        GameVars.gameData.logs = [];
        GameManager.writeGameData();

        GameVars.resumedGame = false;

        GameManager.enterBoardScene();
    }

    private onBlockFitting(blockData: Templok.BlockData, p: {c: number, r: number}, isOnNiche: boolean, score: number): void {

        GameVars.score = score;

        // LA ACCION
        const action = {type: Templok.ActionType.DROP_BLOCK, data:  {p: p, blockData: blockData, isOnNiche: isOnNiche}};
        GameVars.gameData.logs.push(action);
        GameManager.writeGameData();
        
        BoardScene.currentInstance.onBlockFitting(GameVars.selectedBlock, this.selectedBlockPosition);

        BoardContainer.currentInstance.blocksDispenser.checkBlocks();

        GameVars.selectedBlock.destroy();
        GameVars.selectedBlock = null;
        this.selectedBlockPosition = null;

        BoardContainer.currentInstance.unMarkDropPosition();
        BoardContainer.currentInstance.unMarkShadows();
    }

    private onMatch(
            p: {c: number, r: number}, 
            blockData: Templok.BlockData,
            isOnNiche: boolean,
            rows: number[], columns: number[], 
            duplicatedCellsData: {p: {c: number, r: number}, type: number}[], 
            score: number, 
            comboPoints: number
        ): void {

        GameVars.score = score;

        const action = {type: Templok.ActionType.DROP_BLOCK, data: {p: p, blockData: blockData, isOnNiche: isOnNiche}};
        GameVars.gameData.logs.push(action);
        GameManager.writeGameData();
                
        BoardScene.currentInstance.onBlockFitting(GameVars.selectedBlock, this.selectedBlockPosition);
        
        BoardScene.currentInstance.onMatch(rows, columns, duplicatedCellsData, comboPoints);

        BoardContainer.currentInstance.blocksDispenser.checkBlocks();

        GameVars.selectedBlock.destroy();
        GameVars.selectedBlock = null;
        this.selectedBlockPosition = null;

        BoardContainer.currentInstance.unMarkDropPosition();
        BoardContainer.currentInstance.unMarkShadows();
    }

    private spawnBlocks(newBlocksData: Templok.BlockData[]): void {

        GameVars.templokEngine.setSeed(GameVars.seed);
        
        const boardContainer = BoardContainer.currentInstance;

        boardContainer.spawnBlock(newBlocksData[0]);
        boardContainer.spawnBlock(newBlocksData[1]);
        boardContainer.spawnBlock(newBlocksData[2]);

        BoardContainer.currentInstance.blocksDispenser.checkBlocks();
    }

    private onEmptyBlocksDispenser(): void {

        const seed = Math.floor(Math.random() * 1e5);

        const action = {type: Templok.ActionType.SET_SEED, data: {seed: seed}};
        GameVars.gameData.logs.push(action);
        GameManager.writeGameData();

        GameVars.templokEngine.setSeed(seed);
        GameVars.templokEngine.spawnBlocks();
    }

    private onBlockPlacedInNiche(blockData: Templok.BlockData): void {

        const action = {type: Templok.ActionType.DROP_BLOCK_INTO_NICHE, data: {blockData: blockData}};
        GameVars.gameData.logs.push(action);
        GameManager.writeGameData();
        
        BoardContainer.currentInstance.moveBlockToNiche(GameVars.selectedBlock);

        GameVars.selectedBlock = null;
        this.selectedBlockPosition = null;
    }

    private onReRollBlockDetermined(blockData: Templok.BlockData): void {

        GameVars.reRolling = true;

        BoardContainer.currentInstance.reRoll(blockData);
    }

    private onRotatedBlockDetermined(blockData: Templok.BlockData): void {

        const niche = BoardContainer.currentInstance.blocksDispenser.niche;
        niche.rotate(blockData);
    }

    private onSelectedBlockPositionMarked(p: {c: number, r: number}): void {

        BoardContainer.currentInstance.markDropPosition(p, GameVars.selectedBlock.blockData);
    }

    private addEngineListeners(): void {

        GameVars.templokEngine.addEventListener(Templok.Event.SPAWN_BLOCKS, this.spawnBlocks, this);
        GameVars.templokEngine.addEventListener(Templok.Event.BLOCKS_DISPENSER_EMPTY, this.onEmptyBlocksDispenser, this);
        GameVars.templokEngine.addEventListener(Templok.Event.BLOCK_FITTING, this.onBlockFitting, this);
        GameVars.templokEngine.addEventListener(Templok.Event.BLOCK_NOT_FITTING, this.onBlockNotFitting, this);
        GameVars.templokEngine.addEventListener(Templok.Event.MATCH, this.onMatch, this);
        GameVars.templokEngine.addEventListener(Templok.Event.BLOCK_PLACED_IN_NICHE, this.onBlockPlacedInNiche, this);
        GameVars.templokEngine.addEventListener(Templok.Event.REROLL_BLOCK_DETERMINED, this.onReRollBlockDetermined, this);
        GameVars.templokEngine.addEventListener(Templok.Event.BLOCK_ROTATED, this.onRotatedBlockDetermined, this);
        GameVars.templokEngine.addEventListener(Templok.Event.MARK_SELECTED_BLOCK_POSITION, this.onSelectedBlockPositionMarked, this);
        GameVars.templokEngine.addEventListener(Templok.Event.GAME_OVER, this.onGameOver, this);
    }
}
